import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiEdit3, FiEye } from "react-icons/fi";
import { FaRegTrashAlt } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import toastr from "toastr";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { isArray } from "lodash";
import {
  getAllIncidents,
  deleteIncidentDetails,
  revertedInvestigation,
} from "app/_services/ehs/ehsIncidentServices";
import {
  contractorDesignationLabel,
  contractorDropdownLabel,
  employeeDesignationLabel,
  employeeDropdownLabel,
  formatDDMMYYYYbyYYYYMMDD,
  fullNameLabel,
  paginationOptionsObj,
} from "app/_helpers/helper";
import {
  incidentStatuses,
  incidentTypes,
  severities,
  getIncidentStatusClass,
  getIncidentSeverityClass,
  incidentFilterFields,
  validateRowFilter,
  CURRENT_SEVERITY,
  staffType,
  INCIDENT_STATUS_VIEW,
  getReturnRecord,
  checkStatusByFilter,
  checkLtiWithType,
} from "./CONSTANTS";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import {
  isUserRO,
  isUserMM,
  isUserSO,
  getLoggedInUserId,
  checkStringsAreEqual,
  checkUserIsOfSameSite,
  isUserInvestigator,
  LOGGED_USER_ID,
} from "../IncidentManagement/Helper";
import { useForm } from "app/_helpers/hooks";
import IncidentFilters from "./IncidentFilters.component";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import paginationFactory from "react-bootstrap-table2-paginator";
import { DDMMYYYYFormat, isBetween, YYYYMMDDFormat } from "app/_helpers/dateHelper";
import { ACTIVE_MODULE } from "app/_constants/constant";
import Decline from "./DeclinePopup";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { MdRefresh } from "react-icons/md";
import { GrRevert } from "react-icons/gr";
import { GiReturnArrow } from "react-icons/gi";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
const { SearchBar } = Search;

function MyApprovalAction({
  match: {
    params: { siteId },
  },
  viewIncident,
}) {
  const [tab, setTab] = useState(
    isUserRO() ? 1 : isUserSO() ? 2 : isUserMM() ? 3 : isUserInvestigator() ? 4 : 0
  );
  const [incidents, setIncidents] = useState([]);
  const [incidentsFilter, setIncidentsFilter] = useState([]);
  const [incidentsTable, setIncidentsTable] = useState([]);
  const [filterForm, onChangeFilter, setFilterForm] = useForm({}, incidentFilterFields);
  const [tabCount, setTabCount] = useState({});
  const [showFilter, setShowFilter] = useState(false);
  const [activeReturn, setActiveReturn] = useState(false);
  const [loading, setLoading] = useState(true);

  const rowStyle = (row) => {
    if (row.isBack || row?.investigationDetails?.reverted) {
      return { backgroundColor: "#d2ced6" };
    }
  };

  const onReset = () => setFilterForm({});

  const revertInvestigation = (id, obj) => {
    revertedInvestigation(id, obj).then((response) => {
      if (response?.status) {
        toastr.success("Returned Successfully");
        getAllIncidentData(siteId);
      }
    });
  };

  const deleteIncident = (id) => {
    confirmAlert({
      title: "Delete Incident Details.",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const response = await deleteIncidentDetails(id);

            if (!response?.status) return toastr.error(response?.message);

            toastr.success("Deleted successfully.");
            setIncidents(incidents.filter((inc) => inc.id !== id));
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const isUserInvestigatorOfIncident = (row) => {
    let isInvetigator = false;
    let investigatorId = row?.investigationDetails?.investigator.id;
    let currentId = getLoggedInUserId();
    if (investigatorId == currentId) {
      isInvetigator = true;
    }
    return isInvetigator;
  };

  const checkViewAndEditPermission = useCallback(
    (row) => {
      //let globalPermissions = JSON.parse(localStorage.getItem("globalPermissions"));
      let viewPage = "review";
      let editPage = "review";

      let investigatorId = row?.investigationDetails?.investigator.id;
      let currentId = getLoggedInUserId();
      if (
        checkStringsAreEqual(
          row.incidentStatus,
          incidentStatuses.investigationProgress
        ) &&
        investigatorId == currentId
      ) {
        viewPage = "review";
        editPage = "investigation";
      }

      if (checkStringsAreEqual(row.incidentStatus, incidentStatuses.draft)) {
        viewPage = "report";
        editPage = "report";
      }

      let viewLink = null;
      if (viewPage) {
        viewLink =
          (siteId ? `/sites/${siteId}` : "") +
          "/health-safety-and-environment/incident-management/" +
          viewPage +
          "/view/" +
          row.id;
      }

      let editLink = null;
      if (editPage) {
        editLink =
          (siteId ? `/sites/${siteId}` : "") +
          "/health-safety-and-environment/incident-management/" +
          editPage +
          "/edit/" +
          row.id;
      }

      return { viewLink, editLink };
    },
    [siteId]
  );

  const showEditIcon = useCallback((row) => {
    let showEdit = false;
    let tabNumber = null;
    if (
      isUserRO() &&
      checkUserIsOfSameSite(row?.siteId) &&
      checkStringsAreEqual(row.incidentStatus, incidentStatuses.draft) &&
      row?.reportedBy === LOGGED_USER_ID()
    ) {
      showEdit = true;
      tabNumber = 1;
    }
    if (
      isUserSO() &&
      checkUserIsOfSameSite(row?.siteId) &&
      (checkStringsAreEqual(row.incidentStatus, incidentStatuses.open) ||
        checkStringsAreEqual(
          row.incidentStatus,
          incidentStatuses.investigationCompleted
        ) ||
        checkStringsAreEqual(row.incidentStatus, incidentStatuses.capaCompleted)) &&
      checkStringsAreEqual(row.reportAtLabel, "so")
    ) {
      showEdit = true;
      tabNumber = 2;
    }
    if (
      isUserMM() &&
      checkUserIsOfSameSite(row?.siteId) &&
      (checkStringsAreEqual(row.incidentStatus, incidentStatuses.capaReviewed) ||
        checkStringsAreEqual(
          row.incidentStatus,
          incidentStatuses.investigationReviewed
        ) ||
        checkStringsAreEqual(row.incidentStatus, incidentStatuses.mmReview)) &&
      checkStringsAreEqual(row.reportAtLabel, "mm")
    ) {
      showEdit = true;
      tabNumber = 3;
    }
    if (
      isUserInvestigatorOfIncident(row) &&
      checkUserIsOfSameSite(row?.siteId) &&
      checkStringsAreEqual(row.incidentStatus, incidentStatuses.investigationProgress)
    ) {
      showEdit = true;
      tabNumber = 4;
    }

    return { showEdit, tabNumber };
  }, []);
  // return <ManageIncidents {...props} myApprovalHistory />;
  const sortableColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },
    {
      dataField: "incidentId",
      text: "Incident Id.",
      sort: true,
      formatter: (incidentId, row) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">View</Tooltip>}
        >
          <Link
            className="icons text-cyanBlue"
            to={`/health-safety-and-environment/incident-management/report/view/${row.id}`}
          >
            {incidentId}
          </Link>
        </OverlayTrigger>
      ),
    },
    {
      dataField: "site.siteId",
      text: "Location Code",
      sort: true,
      formatter: (col, row) => {
        return (
          <span title={row?.site ? row?.site?.name : ""} className="icons text-cyanBlue">
            {col}
          </span>
        );
      },
    },
    {
      dataField: "site.name",
      text: "Location Name",
      sort: true,
    },
    {
      dataField: "formattedType",
      text: "Incident Type",
      sort: true,
    },
    {
      dataField: "formattedIncidentDate",
      text: "Incident Date",
      sort: true,
    },
    {
      dataField: "generalReasons",
      text: "General-Info Reasons",
      sort: true,
      isExcelOnly: true,
    },
    {
      dataField: "formattedReportedBy",
      text: "Reported By",
      sort: true,
    },
    {
      dataField: "staffData.email",
      text: "Email ID",
      sort: true,
      isExcelOnly: true,
    },
    {
      dataField: "staffData.employeeId",
      text: "Emp ID",
      sort: true,
      isExcelOnly: true,
    },
    {
      dataField: "staffData.designation",
      text: "Designation",
      sort: true,
      isExcelOnly: true,
    },
    {
      dataField: "formattedDesignation",
      text: "Designation",
      sort: true,
      isTableOnly: true,
    },
    {
      dataField: "formattedSeverity",
      text: "Severity",
      sort: true,
    },

    {
      dataField: "area.name",
      text: "Area",
      sort: true,
    },

    {
      dataField: "department.name",
      text: "Department",
      sort: true,
    },
    {
      dataField: "formattedIncidentStatus",
      text: "Status",
      sort: true,
    },
    {
      dataField: "shift",
      text: "Shift",
      sort: true,
    },
    {
      dataField: "formattedStaffType",
      text: "Staff Type",
      sort: true,
    },
    {
      dataField: "createdAtView",
      text: "Time Stamp",
      sort: true,
    },

    {
      dataField: "create",
      text: "Action",
      formatter: (_rowContent, row) => {
        let linkData = checkViewAndEditPermission(row);
        let editLink = linkData.editLink;
        let viewLink = linkData.viewLink;

        let permissionName = "reviewer";
        let showEditIcon = false;

        if (
          isUserRO() &&
          checkUserIsOfSameSite(row?.siteId) &&
          checkStringsAreEqual(row.incidentStatus, incidentStatuses.draft) &&
          row?.reportedBy === LOGGED_USER_ID()
        ) {
          showEditIcon = true;
        }
        if (
          isUserSO() &&
          checkUserIsOfSameSite(row?.siteId) &&
          (checkStringsAreEqual(row.incidentStatus, incidentStatuses.open) ||
            checkStringsAreEqual(
              row.incidentStatus,
              incidentStatuses.investigationCompleted
            ) ||
            checkStringsAreEqual(row.incidentStatus, incidentStatuses.capaCompleted)) &&
          checkStringsAreEqual(row.reportAtLabel, "so")
        ) {
          showEditIcon = true;
        }
        if (
          isUserMM() &&
          checkUserIsOfSameSite(row?.siteId) &&
          (checkStringsAreEqual(row.incidentStatus, incidentStatuses.capaReviewed) ||
            checkStringsAreEqual(
              row.incidentStatus,
              incidentStatuses.investigationReviewed
            ) ||
            checkStringsAreEqual(row.incidentStatus, incidentStatuses.mmReview)) &&
          checkStringsAreEqual(row.reportAtLabel, "mm")
        ) {
          showEditIcon = true;
        }
        if (
          isUserInvestigatorOfIncident(row) &&
          checkUserIsOfSameSite(row?.siteId) &&
          checkStringsAreEqual(row.incidentStatus, incidentStatuses.investigationProgress)
        ) {
          showEditIcon = true;
        }

        let showDeleteIcon =
          isUserRO() && checkStringsAreEqual(row.incidentStatus, incidentStatuses.draft);
        // if (row.incidentStatus === incidentStatuses.initialReview || row.incidentStatus === incidentStatuses.open) permissionName = "investigator";
        // else if (row.incidentStatus === incidentStatuses.investigation) permissionName = "reviewer";
        // else if (row.incidentStatus === incidentStatuses.finalReview) permissionName = "closer";

        return (
          <div className="actionIconsGroup">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">View</Tooltip>}
            >
              <Link className="icons text-cyanBlue" to={viewLink}>
                <FiEye />
              </Link>
            </OverlayTrigger>

            {showEditIcon && !viewIncident && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
              >
                <Link className="icons text-cyanBlue" to={editLink}>
                  <FiEdit3 />
                </Link>
              </OverlayTrigger>
            )}

            {tab === 4 && (
              <Decline
                onSubmit={(obj) =>
                  revertInvestigation(row?.id, { revertMessage: obj.comment })
                }
                title="Return"
                name={
                  <CustomTooltip tooltip="Return">
                    <MdRefresh size={20} />
                  </CustomTooltip>
                }
                iconClass={"icons text-cyanBlue"}
              />
            )}

            {showDeleteIcon && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top"> Delete</Tooltip>}
              >
                <a
                  href
                  className="icons pointer text-danger"
                  onClick={() => deleteIncident(row.id)}
                >
                  <FaRegTrashAlt />
                </a>
              </OverlayTrigger>
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    const obj = {};
    setIncidentsTable(
      incidents.filter((row) => {
        const { showEdit, tabNumber } = showEditIcon(row);
        if (!obj.hasOwnProperty(tabNumber)) {
          obj[tabNumber] = 1;
        } else {
          obj[tabNumber] += 1;
        }
        return showEdit ? true : false;
      })
    );
    setTabCount(obj);
  }, [checkViewAndEditPermission, incidents, showEditIcon]);

  const getAllIncidentData = async (siteId) => {
    // getAllIncidents(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
    //   if (!response?.data) return;
    //   setIncidents(
    //     response.data.incidentDetails.map((inc, idx) => {
    //       const severity = CURRENT_SEVERITY(inc);
    //       return {
    //         ...inc,
    //         sid: idx + 1,
    //         formattedType: incidentTypes[inc?.type],
    //         formattedIncidentDate: DDMMYYYYFormat(inc?.incidentDate),
    //         formattedReportedBy:
    //           inc?.staffType === "employee"
    //             ? `${employeeDropdownLabel(inc?.staffData)}`
    //             : inc?.staffType === "contractor"
    //             ? `${contractorDropdownLabel(inc?.staffData)}`
    //             : inc?.otherStaffName,
    //         formattedSeverity: (
    //           <div className={getIncidentSeverityClass(severity)}>
    //             {severities[severity]}
    //           </div>
    //         ),
    //         formattedIncidentStatus: INCIDENT_STATUS_VIEW(
    //           inc?.incidentStatus,
    //           inc?.investigationDetails?.reverted,
    //           inc?.isBack,
    //           inc
    //         ),
    //         formattedStaffType: staffType[inc?.staffType],
    //       };
    //     })
    //   );
    // });

    try {
      const response = await getAllIncidents(siteId ? `filter[siteId]=${siteId}` : "");

      if (!response?.data) {
        // Handle the case where data is not received
        setLoading(false);
        return;
      }
      setIncidents(
        response.data.incidentDetails.map((inc, idx) => {
          const severity = CURRENT_SEVERITY(inc);
          return {
            ...inc,
            sid: idx + 1,
            formattedType: incidentTypes[inc?.type],
            formattedIncidentDate: DDMMYYYYFormat(inc?.incidentDate),
            formattedReportedBy:
              inc?.staffType === "employee"
                ? `${fullNameLabel(inc?.staffData)}`
                : inc?.staffType === "contractor"
                ? `${fullNameLabel(inc?.staffData)}`
                : inc?.otherStaffName,
            formattedDesignation:
              inc?.staffType === "employee"
                ? `${employeeDesignationLabel(inc?.staffData)}`
                : inc?.staffType === "contractor"
                ? `${contractorDesignationLabel(inc?.staffData)}`
                : "NA",
            formattedSeverity: (
              <div className={getIncidentSeverityClass(severity)}>
                {severities[severity]}
              </div>
            ),
            formattedIncidentStatus: INCIDENT_STATUS_VIEW(
              inc?.incidentStatus,
              inc?.investigationDetails?.reverted,
              inc?.isBack,
              inc
            ),
            formattedStaffType: staffType[inc?.staffType],
          };
        })
      );

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error as needed, e.g., show an error message
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllIncidentData(siteId);
  }, [siteId]);

  useEffect(() => {
    if (filterForm.hasOwnProperty("ltiHoursUpdate") && filterForm.ltiHoursUpdate === "")
      delete filterForm.ltiHoursUpdate;
    if (
      filterForm.hasOwnProperty("reportEvidencesRequired") &&
      filterForm.reportEvidencesRequired === ""
    )
      delete filterForm.reportEvidencesRequired;

    setIncidentsFilter(
      incidentsTable?.filter?.((row) => {
        let showEditIcon = false;

        if (
          tab === 1 &&
          isUserRO() &&
          checkUserIsOfSameSite(row?.siteId) &&
          checkStringsAreEqual(row.incidentStatus, incidentStatuses.draft) &&
          row?.reportedBy === LOGGED_USER_ID()
        ) {
          showEditIcon = true;
        }
        if (
          tab === 2 &&
          isUserSO() &&
          checkUserIsOfSameSite(row?.siteId) &&
          (checkStringsAreEqual(row.incidentStatus, incidentStatuses.open) ||
            checkStringsAreEqual(
              row.incidentStatus,
              incidentStatuses.investigationCompleted
            ) ||
            checkStringsAreEqual(row.incidentStatus, incidentStatuses.capaCompleted)) &&
          checkStringsAreEqual(row.reportAtLabel, "so")
        ) {
          showEditIcon = true;
        }
        if (
          tab === 3 &&
          isUserMM() &&
          checkUserIsOfSameSite(row?.siteId) &&
          (checkStringsAreEqual(row.incidentStatus, incidentStatuses.capaReviewed) ||
            checkStringsAreEqual(
              row.incidentStatus,
              incidentStatuses.investigationReviewed
            ) ||
            checkStringsAreEqual(row.incidentStatus, incidentStatuses.mmReview)) &&
          checkStringsAreEqual(row.reportAtLabel, "mm")
        ) {
          showEditIcon = true;
        }
        if (
          tab === 4 &&
          isUserInvestigatorOfIncident(row) &&
          checkUserIsOfSameSite(row?.siteId) &&
          checkStringsAreEqual(row.incidentStatus, incidentStatuses.investigationProgress)
        ) {
          showEditIcon = true;
        }

        const severity = CURRENT_SEVERITY(row);

        if (filterForm?.startDate && filterForm?.endDate) {
          showEditIcon = isBetween(
            row?.incidentDate,
            YYYYMMDDFormat(filterForm.startDate),
            YYYYMMDDFormat(filterForm.endDate)
          );
        }

        if (filterForm?.bodyParts) {
          const bodyPartObj = row?.personalDetails?.find((d) =>
            d.bodyParts?.split(",")?.includes(filterForm?.bodyParts)
          );
          if (!bodyPartObj) showEditIcon = false;
        }

        if (filterForm?.injuryOutcome) {
          const Obj = row?.personalDetails?.find(
            (d) => d.outcome === filterForm?.injuryOutcome
          );
          if (!Obj) showEditIcon = false;
        }

        if (+filterForm?.ltiHoursUpdate === 0 || +filterForm?.ltiHoursUpdate === 1) {
          const isLtiHoursUpdate =
            checkLtiWithType.includes(row?.type) &&
            row?.isPersonalInjury &&
            row?.ltiHoursUpdate === +filterForm?.ltiHoursUpdate;
          if (!isLtiHoursUpdate) showEditIcon = false;
        }

        if (
          +filterForm?.reportEvidencesRequired === 0 ||
          +filterForm?.reportEvidencesRequired === 1
        ) {
          const evidenceFlag = !!(
            (+filterForm?.reportEvidencesRequired && row?.reportEvidencesRequired) ||
            (!+filterForm?.reportEvidencesRequired && !row?.reportEvidencesRequired)
          );
          if (!evidenceFlag) showEditIcon = false;
        }

        if (filterForm?.incidentStatus && showEditIcon) {
          showEditIcon = checkStatusByFilter(filterForm?.incidentStatus, row);
        }

        if (activeReturn && !row?.investigationDetails?.reverted && !row?.isBack)
          showEditIcon = false;

        if (
          isArray(filterForm?.generalReasonsFilter) &&
          filterForm?.generalReasonsFilter.length
        ) {
          const areAllPropertiesTrue = filterForm?.generalReasonsFilter.every(
            (property) => row?.[property] === true
          );
          if (!areAllPropertiesTrue) {
            showEditIcon = false;
          }
        }

        if (showEditIcon)
          showEditIcon = validateRowFilter(filterForm, { ...row, severity });

        return showEditIcon;
      })
    );
  }, [incidentsTable, tab, filterForm, activeReturn]);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Incident Management",
            path:
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/incident-management",
          },
          { name: "My Approval Actions", path: "#" },
        ]}
        module={ACTIVE_MODULE.incident}
      />
      <div className="card p-3">
        <div className="simple-card-title cardCustomHeader">
          {/* <div className="col-4"> */}
          <h3 class="text-capitalize mb-1">My Approval Actions</h3>
          <FilterBtn setShowFilter={setShowFilter} />
          {/* </div> */}
          <BackBtn url={"/health-safety-and-environment/incident-management"} />
        </div>
        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber">
          <div className="hseMenuLinks card">
            {isUserRO() && (
              <a
                href
                onClick={() => setTab(1)}
                className={`pointer${tab === 1 ? " active" : ""}`}
              >
                Reporting Officer ({tabCount[1] || 0})
              </a>
            )}
            {isUserSO() && (
              <a
                href
                onClick={() => setTab(2)}
                className={`pointer${tab === 2 ? " active" : ""}`}
              >
                Safety Officer ({tabCount[2] || 0})
              </a>
            )}
            {isUserMM() && (
              <a
                href
                onClick={() => setTab(3)}
                // style={{pointerEvents: 'none'}}
                className={`pointer${tab === 3 ? " active" : ""}`}
              >
                Mines Manager ({tabCount[3] || 0})
              </a>
            )}
            {isUserInvestigator() && (
              <a
                href
                onClick={() => setTab(4)}
                className={`pointer${tab === 4 ? " active" : ""}`}
              >
                Investigator ({tabCount[4] || 0})
              </a>
            )}
          </div>
        </div>
        {/* <ToolkitProvider
          striped
          keyField="id"
          data={incidentsFilter?.map((d, idx) => ({ ...d, sid: idx + 1 }))}
          columns={sortableColumn}
        > */}
        {/* {(props) => (
            <> */}
        {/* {showFilter && (
                <IncidentFilters
                  fields={incidentFilterFields}
                  setForm={setFilterForm}
                  form={filterForm}
                  onChange={onChangeFilter}
                  onReset={onReset}
                />
              )} */}
        {/* <div className="material-master-table incidentTable"> */}
        {/* <BootstrapTable
                  rowStyle={rowStyle}
                  {...props.baseProps}
                  bootstrap4
                  noDataIndication={"Table is empty"}
                  pagination={paginationFactory({
                    ...paginationOptionsObj,
                    totalSize: Array.isArray(incidentsFilter)
                      ? incidentsFilter.length
                      : 0,
                  })}
                  /> */}
        {!loading ? (
          <SearchBootstrapTable
            rowStyle={rowStyle}
            searchKey={"myApprovalActionIMSDesktopSearch"}
            data={incidentsFilter}
            columns={sortableColumn}
            tableKey="myApprovalActionIM"
            defaultHideColumn={["formattedReportedBy", "site.siteId", "createdAtView"]}
            tableBeforeSearch={() =>
              showFilter ? (
                <IncidentFilters
                  fields={incidentFilterFields}
                  setForm={setFilterForm}
                  form={filterForm}
                  onChange={onChangeFilter}
                  onReset={onReset}
                />
              ) : (
                <></>
              )
            }
            tableToolbarBeforeView={() => getReturnRecord(activeReturn, setActiveReturn)}
            // downloadPermission={"global_globalConfiguration_download"}
          />
        ) : (
          <NetZeroLoader />
        )}

        {/* </div> */}
        {/* </> */}
        {/* )} */}
        {/* </ToolkitProvider> */}
      </div>
    </>
  );
}

export default MyApprovalAction;
